"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIteratee = void 0;
const iteratee_1 = __importDefault(require("../iteratee"));
const baseIteratee_1 = __importDefault(require("./baseIteratee"));
/**
 * Gets the appropriate "iteratee" function. If `iteratee` is customized,
 * this function returns the custom method, otherwise it returns `baseIteratee`.
 * If arguments are provided, the chosen function is invoked with them and
 * its result is returned.
 *
 * @private
 * @param {*} [value] The value to convert to an iteratee.
 * @param {number} [arity] The arity of the created iteratee.
 * @returns {Function} Returns the chosen function or its result.
 */
function getIteratee() {
    var result = iteratee_1.default;
    result = result === iteratee_1.default ? baseIteratee_1.default : result;
    return arguments.length ? result(arguments[0], arguments[1]) : result;
}
exports.getIteratee = getIteratee;
exports.default = getIteratee;
